type SvgProps = React.SVGProps<SVGSVGElement>;

export const PaperWithTick = (props: SvgProps) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
  >
    <path
      d="M8.41273 0H2.92123C2.45711 0 2.01199 0.184374 1.6838 0.512563C1.35561 0.840752 1.17123 1.28587 1.17123 1.75V14H12.8379V4.42517L8.41273 0ZM8.75457 1.9915L10.8464 4.08333H8.75457V1.9915ZM2.3379 12.8333V1.75C2.3379 1.59529 2.39936 1.44692 2.50876 1.33752C2.61815 1.22812 2.76652 1.16667 2.92123 1.16667H7.5879V5.25H11.6712V12.8333H2.3379ZM8.92548 7.6545L9.75032 8.47933L7.65848 10.5706C7.49598 10.7331 7.30305 10.862 7.09071 10.95C6.87837 11.038 6.65078 11.0833 6.42094 11.0833C6.1911 11.0833 5.96352 11.038 5.75118 10.95C5.53884 10.862 5.34591 10.7331 5.1834 10.5706L4.25882 9.646L5.08365 8.82117L6.00882 9.74575C6.11986 9.85193 6.26759 9.9112 6.42123 9.9112C6.57488 9.9112 6.7226 9.85193 6.83365 9.74575L8.92548 7.6545Z"
      fill="currentColor"
    />
  </svg>
);
